import { useContext, useState } from "react";
import { Box, Button, Flex } from "@chakra-ui/react";
import RichTextEditor from "./RichTextEditor";
import CustomInput from "components/common/customInput/CustomInput";
import { appRequest } from "routes";
import { AppContext } from "AppProvider/AppContext";
import ShadowBox from "components/common/ShadowBox/ShadowBox";

export default function AddWord(): JSX.Element {
  const [editorHtml, setEditorHtml] = useState("");
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const { toastNotify, workFlowData } = useContext(AppContext);

  const handleSaveWord = async () => {
    try {
      setLoading(true);

      const values = {
        title: title,
        content: editorHtml,
      };
      const data = {
        values: values,
        type: "word",
        activeWorkflow: workFlowData._id,
      };
      if (values) {
        const response: any = await appRequest("document", "create", data);
        if (response.status === "success") {
          toastNotify({
            title: `Word Created successfully`,
            message: response.message || "Something went wrong.",
            type: "success",
          });
        } else {
          toastNotify({
            title: `Error getting the word.`,
            message: response.message || "Something went wrong.",
            type: "error",
          });
        }
      }
    } catch (err: any) {
      toastNotify({
        title: `Error getting the word.`,
        message: err.message || "Something went wrong.",
        type: "error",
      });
    } finally {
      setLoading(false);
      setEditorHtml("");
      setTitle("");
    }
  };

  return (
    <ShadowBox>
      <CustomInput
        name="title"
        label="Add Title"
        value={title}
        onChange={(e: any) => setTitle(e.target.value)}
      />
      <Box h="350px" mt={2}>
        <RichTextEditor editorHtml={editorHtml} setEditorHtml={setEditorHtml} />
      </Box>
      <Flex alignItems="center" gap={2} justifyContent="end">
        <Button
          onClick={handleSaveWord}
          bg="green.400"
          color="white"
          _hover={{ bg: "green.500" }}
        >
          Submit
        </Button>
        <Button
          onClick={() => {
            setEditorHtml("");
            setTitle("");
          }}
          colorScheme="red"
        >
          Cancel
        </Button>
      </Flex>
    </ShadowBox>
  );
}
